import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Palette, Wand2, Download } from 'lucide-react';
const steps = [{
  icon: MessageSquare,
  title: 'Describe Your Vision',
  description: 'Tell us about your character, personality, and preferred vibes. Reference images help!'
}, {
  icon: Palette,
  title: 'Choose Your Style',
  description: 'Pick from our diverse range of art styles or request a custom blend.'
}, {
  icon: Wand2,
  title: 'We Create Magic',
  description: "Our artists get to work. You'll receive drafts and can request revisions."
}, {
  icon: Download,
  title: 'Download & Play',
  description: 'Receive your high-res files and start using your new identity everywhere.'
}];
export function HowItWorksSection() {
  return <section id="how-it-works" className="py-24 bg-[#0F0F1A]" data-id="element-121">
      <div className="container mx-auto px-4" data-id="element-122">
        <div className="text-center mb-16" data-id="element-123">
          <h2 className="text-3xl md:text-5xl font-bold font-display mb-4" data-id="element-124">
            How It <span className="text-cyan-400" data-id="element-125">Works</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-126">
            Four simple steps to your new digital identity.
          </p>
        </div>

        <div className="relative" data-id="element-127">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-0 right-0 h-0.5 bg-gradient-to-r from-fuchsia-500/0 via-fuchsia-500/50 to-fuchsia-500/0" data-id="element-128" />

          <div className="grid md:grid-cols-4 gap-8" data-id="element-129">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center" data-id="element-130">
                <div className="w-24 h-24 rounded-full bg-[#0B0B15] border-4 border-fuchsia-500/20 flex items-center justify-center mb-6 relative z-10" data-id="element-131">
                  <step.icon className="w-10 h-10 text-fuchsia-400" data-id="element-132" />
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-cyan-500 flex items-center justify-center text-black font-bold text-sm" data-id="element-133">
                    {index + 1}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-white mb-3 font-display" data-id="element-134">
                  {step.title}
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-135">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}